import { lazy } from 'react'

export const BadHabitsV1 = lazy(() => import('./v1/BadHabitsV1'))
export const KitBadHabitsV1 = lazy(() => import('./kitV1/KitBadHabitsV1'))
